// Выравнивание текста на картинке. Все числа — доли картинки (0..1).
// box = { left, right, top, bottom } — реальные границы текста, их считает сервер.

// Края картинки с отступом 5%, чтобы текст не прилипал к краю.
export const CANVAS_BOX = { left: 0.05, right: 0.95, top: 0.05, bottom: 0.95 };

export const HORIZONTAL = ['left', 'hcenter', 'right'];

const round = (n) => Math.round(Math.min(1, Math.max(0, n)) * 10000) / 10000;

// Что поменять в поле (x или y), чтобы его блок встал по краю или по центру
// опорного блока. field.align нужен, потому что x — это не всегда левый край:
// для текста «по центру метки» x — середина, для «влево от метки» — правый край.
export const computeAlignment = (field, own, ref, op) => {
  const width = own.right - own.left;
  const height = own.bottom - own.top;

  if (HORIZONTAL.includes(op)) {
    let left = ref.left;
    if (op === 'hcenter') left = (ref.left + ref.right) / 2 - width / 2;
    if (op === 'right') left = ref.right - width;

    let x = left;
    if (field.align === 'center') x = left + width / 2;
    if (field.align === 'right') x = left + width;
    return { x: round(x) };
  }

  let top = ref.top;
  if (op === 'vmiddle') top = (ref.top + ref.bottom) / 2 - height / 2;
  if (op === 'bottom') top = ref.bottom - height;
  return { y: round(top) };
};
